export default {
    name: 'task',
    data: () => ({}),
    methods: {
        removeLimit(index) {
            this.current_task.limits.splice(index, 1);
        },
        async createTask() {
            const res = this.$communicator.then(
                this,
                await this.$communicator("create_task", {
                    params: this.current_task,
                })
            );
            if (res) {
                this.cancelClicked()
            }
        },
        async updateTask() {
            const res = this.$communicator.then(
                this,
                await this.$communicator("update_task", {
                    arguments: [this.current_task._id, 'update'],
                    params: this.current_task,
                })
            );
            if (res) {
                this.cancelClicked()
            }
        },
        async getTasks() {
            const res = this.$communicator.then(
                this,
                await this.$communicator("get_task_list")
            );
            if (res && res.tasks) {
                this.all_tasks = res.tasks;
            }
        },
        async getTaskById(id) {
            const res = this.$communicator.then(
                this,
                await this.$communicator("get_a_task", {
                    arguments: [id]
                })
            );
            if (res && res.task) {
                this.current_task = res.task
            }
        }
    }
}